// Static marketing / catalog content (not stored in DB)

export const BRAND = {
  name: 'ChatHub',
  tagline: '#1 CRM for Telegram agencies',
  description: 'Run your agency like a pro. Centralise every Telegram conversation, every team member, every paid sale — with DropFans integration baked in.',
};

export const STATS = {
  accountsManaged: 47, accountsLimit: 200,
  chatters: 218, chattersLimit: 800,
  uptime: '99.9%', syncSpeed: '<200ms',
};

// Grille arrêtée par Marlon le 21/09/2026 (doc client « Offre ChatHub »), en ligne le 25/09.
// Les plans ne diffèrent plus seulement par les quotas : chaque fonctionnalité de
// FEATURE_MATRIX est bloquée côté serveur pour les plans qui ne l'ont pas.
export const PLANS = [
  {
    id: 'solo', name: 'Solo', price: 69, popular: false,
    accounts: 1, employees: 5,
    trial: null,   // 26/09 : plus de periode d'essai (decision de Marlon)
    privateWhatsapp: false,
  },
  {
    id: 'starter', name: 'Starter', price: 109, popular: true,
    accounts: 2, employees: 15,
    trial: null,
    privateWhatsapp: false,
  },
  {
    id: 'business', name: 'Business', price: 249, popular: false,
    accounts: 5, employees: 40,
    trial: null,
    privateWhatsapp: true,
  },
  {
    id: 'enterprise', name: 'Enterprise', price: 449, popular: false,
    accounts: 10, employees: null, // unlimited
    trial: null,
    privateWhatsapp: true,
  },
];

// 25/09 (Marlon) : payer 3 mois d'avance, -10 %. Un prelevement au lieu de trois.
export const RYTHMES = [
  { key: 'month', mois: 1, remise: 0, fr: 'Mensuel', en: 'Monthly' },
  { key: 'quarter', mois: 3, remise: 0.10, fr: '3 mois', en: '3 months' },
  { key: 'year', mois: 12, remise: 0.20, fr: 'Annuel', en: 'Yearly' },
];
// Le prix d'un plan pour un rythme donne (total de la periode).
export const prixPeriode = (plan, rythme) =>
  Math.round(plan.price * rythme.mois * (1 - rythme.remise) * 100) / 100;

// Ce que chaque plan donne. `key` = la clé vérifiée par le serveur (PLAN_FEATURES,
// backend/server.py) : la page et la garde doivent dire la MÊME chose. key null =
// inclus partout, donc rien à garder côté serveur.
const TOUS = ['solo', 'starter', 'business', 'enterprise'];
export const FEATURE_MATRIX = [
  { group: { fr: 'Au quotidien', en: 'Day to day' }, rows: [
    { key: null, fr: 'Messagerie unifiée, box, planning, scripts, vault, listes', en: 'Unified inbox, boxes, planning, scripts, vault, lists', plans: TOUS },
    { key: null, fr: 'Ventes DropFans et PayPal rattachées automatiquement', en: 'DropFans and PayPal sales attributed automatically', plans: TOUS },
    { key: null, fr: 'Liens payants personnalisés', en: 'Personalised paid links', plans: TOUS },
    { key: 'tracking_links', fr: 'Liens de suivi (tracking links)', en: 'Tracking links', plans: TOUS },
    { key: 'ai_assistant', fr: 'Assistant IA pour les chatteurs (5 modes)', en: 'AI assistant for chatters (5 modes)', plans: ['starter', 'business', 'enterprise'] },
    { key: null, fr: 'Journal des messages, temps de réponse, comptabilité', en: 'Message logs, response times, accounting', plans: TOUS },
  ] },
  { group: { fr: 'Pour grandir', en: 'To grow' }, rows: [
    { key: 'auto_notes', fr: 'Notes et étiquettes automatiques', en: 'Automatic notes and tags', plans: ['starter', 'business', 'enterprise'] },
    { key: 'canal', fr: 'Canal : posts, stories, sondages et vocaux programmés, calendrier', en: 'Channel: scheduled posts, stories, polls and voice notes, calendar', plans: ['starter', 'business', 'enterprise'] },
  ] },
  { group: { fr: 'Pour les agences structurées', en: 'For established agencies' }, rows: [
    { key: 'whales', fr: 'Analyse des gros clients et de leurs demandes', en: 'Whale analysis and their requests', plans: ['business', 'enterprise'] },
    { key: 'chatter_reports', fr: 'Rapports, fautes et entraînement IA des chatteurs', en: 'Chatter reports, mistakes and AI training', plans: ['business', 'enterprise'] },
    { key: 'whatsapp_support', fr: 'Support privé WhatsApp', en: 'Private WhatsApp support', plans: ['business', 'enterprise'] },
  ] },
  { group: { fr: 'Sur mesure', en: 'Tailor-made' }, rows: [
    { key: 'custom_dev', fr: 'Fonctionnalités développées pour votre agence', en: 'Features built for your agency alone', plans: ['enterprise'] },
  ] },
];

export const SCRIPT_TAGS = ['Greeting', 'Sales', 'Retention', 'Custom', 'Tease', 'PPV', 'Birthday'];
export const VAULT_TAGS = ['summer', 'premium', 'exclusive', 'free', 'tease', 'vip', 'bundle', 'casual', 'custom', 'fitness'];

export const PERMISSIONS_MATRIX = [
  { cat: 'Telegram', count: 3, perms: ['Manage Telegram accounts', 'Edit Telegram profiles', 'View account tracking & stats'] },
  { cat: 'Messages', count: 11, perms: ['Read', 'Send', 'Delete', 'Forward', 'Manage conversations', 'Pin', 'Mark as unread', 'View message logs', 'Manage boxes', 'Block conversations', 'View & manage blocked list'] },
  { cat: 'Banned words', count: 1, perms: ['Banned words add/remove'] },
  { cat: 'Vault', count: 3, perms: ['View vault', 'Manage vault', 'Send vault media'] },
  { cat: 'Scripts', count: 2, perms: ['View scripts', 'Manage scripts'] },
  { cat: 'Lists', count: 3, perms: ['View lists', 'Assign conversations', 'Manage lists'] },
  { cat: 'Mass DM', count: 2, perms: ['View Mass DM campaigns', 'Run Mass DM campaigns'] },
  { cat: 'Chatters', count: 2, perms: ['View chatters', 'Manage chatters'] },
  { cat: 'Planning', count: 3, perms: ['View own planning', 'Submit own availability', 'Manage shifts & assignments'] },
  { cat: 'DropFans', count: 2, perms: ['Send paid media (DropFans)', 'Configure DropFans (webhook, API key)'] },
  { cat: 'Sales & Reports', count: 4, perms: ['View sales and reports', 'Report a sale', 'Manage sales (approve, edit, delete)', 'View chatter accounting'] },
  { cat: 'Organization', count: 2, perms: ['Edit organization settings', 'Manage roles & permissions'] },
];

export const FAQ = [
  { q: 'What is ChatHub?', a: 'A CRM built specifically for chatting agencies managing multiple Telegram accounts in real-time, with native DropFans integration for paid-media sales attribution.' },
  { q: 'How does the real Telegram connection work?', a: 'You add your phone number, validate with the SMS code (and 2FA if you have it), and ChatHub speaks Telegram exactly like the official iOS app would. Each account is routed through its own mobile proxy so it always appears to come from the same device.' },
  { q: 'How many Telegram accounts can I connect?', a: 'As many as your plan allows. All conversations from all accounts appear in a single unified inbox, synchronised in real-time.' },
  { q: 'Can I control what my chatters see and do?', a: 'Yes. Our RBAC system lets you create custom roles with 39 granular permissions across 12 domains. Every action is verified server-side and logged.' },
  { q: 'Does ChatHub work with DropFans?', a: 'Yes — fully. Plug in your own DropFans API key + webhook secret, and every paid sale is automatically attributed to the chatter who sent the link first in the conversation. ChatHub is an independent product and is not affiliated with DropFans.' },
  { q: 'How is media stored? Do I need to upload it every time?', a: 'No. The first time a media is sent, Telegram returns a permanent file-id that ChatHub caches per account. Every subsequent send re-uses that file-id — zero re-upload, zero bandwidth fees, even for a library of thousands of media.' },
  { q: 'Is there a free trial?', a: 'No. You subscribe and the tool is yours right away — no trial to convert, no surprise on day three. You can change plan or cancel at any time from your account.' },
  { q: 'How does payment work?', a: 'Credit card. Invoices are generated and tracked automatically, and you can change plan or cancel at any time from your account.' },
  { q: 'Is my data secure?', a: 'Encrypted Telegram sessions at rest, RBAC verified server-side on every request, httpOnly cookie auth, CSRF protection, signed DropFans webhooks, row-level isolation between agencies.' },
  { q: 'How fast is the real-time sync?', a: 'Messages arrive via MTProto in under 200ms. No polling, no delays.' },
];
